import { DateTime } from "luxon";
import { formatNumber } from "../games/royalties/currency-formatting";

/**
 * Format a royalty date as a short locale-specific string
 * @param {number} timestamp - The timestamp in milliseconds
 * @returns {string} The formatted date string (e.g., "1/15/2024" in US locale)
 */
export const formatRoyaltyDate = (timestamp) => {
  return DateTime.fromMillis(timestamp).toLocaleString(DateTime.DATE_SHORT);
};

/**
 * Build the secondary text for a royalty list item
 * @param {string} formattedDate - The formatted date string
 * @param {string} royaltyType - The royalty type label
 * @param {string|undefined} gameName - Optional game name
 * @param {string|undefined} edition - Optional edition name
 * @returns {string} The formatted secondary text
 */
export const buildRoyaltySecondaryText = (formattedDate, royaltyType, gameName, edition) => {
  return `${formattedDate} - ${gameName ? `${gameName} - ` : ""}${edition ? `${edition} - ` : ""}${royaltyType}`;
};

/**
 * Build the secondary text for a royalty list item
 * @param {number|undefined} units - The formatted date string
 * @param {string} royaltyType - The royalty type label
 * @param {string|undefined} gameName - Optional game name
 * @param {string|undefined} edition - Optional edition name
 * @returns {string} The formatted secondary text
 */
export const buildRoyaltySecondaryTextWithUnits = (units, royaltyType, gameName, edition) => {
  const unitsText = units === 1 ? "1 unit" : `${formatNumber(units || 0)} units`;
  return [units ? unitsText : undefined, gameName, edition, royaltyType].filter(Boolean).join(" - ");
};
